import './SocialMenu.scss'

import React, { FC } from 'react'

export interface SocialMenuProps {
  isOpened: boolean
}

const SocialMenu: FC<SocialMenuProps> = ({ isOpened }) => {
  return (
    <div className={`social-menu ${isOpened ? 'social-menu--opened': ''}`}>
      <ul>
        <li><a href="https://www.instagram.com/youplanet.es" target="_blank">INSTAGRAM</a></li>
        <li><a href="https://twitter.com/youplanet_es" target="_blank">TWITTER</a></li>
        <li><a href="https://www.linkedin.com/company/10487024" target="_blank">LINKEDIN</a></li>
        <li><a href="https://www.youtube.com/channel/UCk1w46wgvAEXLMu-GjhaSDg" target="_blank">YOUTUBE</a></li>
      </ul>
    </div>
  )
}

export default SocialMenu
